import React from 'react';
import StaffProfileTemplate, {
  ProfileSection,
  ProfileParagraphs,
  ProfileBullets,
  ProfilePublications,
  ProfileContactSection,
} from './StaffProfileTemplate';

const RovithonoYhomeProfile = () => {
  const person = {
    id: 'rovithono-yhome',
    name: 'Rovithono Yhome',
    honorific: 'Ms',
    title: 'Human Resource Manager',
    affiliation: 'The Highland Institute, Kohima, Nagaland',
    image: 'https://customer-assets.emergentagent.com/job_vegr-highland/artifacts/4kwmjpua_Rovithono%20Yhome.jpg',
    email: 'rovi@highlandinstitute.org',
    category: 'Senior Staff',
    testid: 'rovithono-yhome-profile',
  };

  return (
    <StaffProfileTemplate person={person}>
      <ProfileSection title="Intellectual Biography">
        <ProfileParagraphs
          items={[
            "Rovithono Yhome has an academic background in education and works across project coordination, research administration, and community-based initiatives at The Highland Institute. Her interests centre on how collaborative and locally grounded research practices can support public engagement, community wellbeing, and socially responsive knowledge production in Highland Asia. She has also worked on women's health and community-based research, with a particular focus on participatory methodologies and interdisciplinary scholarship in Northeast India.",
            'She currently serves as Human Resource Manager at The Highland Institute in Kohima, Nagaland, where she contributes to institutional coordination, research administration, fieldwork facilitation, and programme development across a range of interdisciplinary initiatives.',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Research Foci & Areas of Work">
        <p className="text-stone-700 leading-relaxed mb-6">
          Her work engages with interdisciplinary and community-based research in Northeast India, particularly in relation to public health, women's wellbeing, urban transformation, and participatory field practices.
        </p>
        <p className="text-stone-700 font-medium mb-4">Key areas of work include:</p>
        <ProfileBullets
          items={[
            "Women's health and community wellbeing",
            'Participatory and community-engaged research',
            'Youth-led and collaborative research initiatives',
            'Urbanisation and tourism research',
            'Educational and programme support',
            'Field coordination and stakeholder engagement',
            'Interdisciplinary research administration',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Highland Institute Projects">
        <ProfileParagraphs
          items={[
            "At The Highland Institute, Rovithono Yhome has contributed to projects connected to public health, urban research, participatory arts, and community engagement. She was involved in the Naga Women's Health Channel initiative, developed in collaboration with the University of Edinburgh and The Highland Institute, which explored women-centred digital health engagement in Northeast India.",
            'More recently, she has contributed to the URBALTOUR project, which examines tourism growth, urban governance, and social transformation in Kohima through field research, stakeholder interviews, and survey coordination.',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Institutional & Collaborative Contributions">
        <ProfileParagraphs
          items={[
            'Alongside her research and administrative responsibilities, Yhome has contributed to workshops, field-based learning initiatives, documentary collaborations, and interdisciplinary research activities involving scholars, students, community organisations, and international partners.',
            'Her work frequently involves field coordination, participant engagement, and community-oriented research processes, helping to strengthen collaborative and locally grounded approaches to knowledge production in Northeast India.',
          ]}
        />
      </ProfileSection>

      <ProfileSection title="Selected Publications & Knowledge Outputs">
        <ProfilePublications
          items={[
            {
              year: '2025',
              citation: (
                <>
                  'Visitor Profiles, Spatial Patterns, and the Dynamics of Tourism in Kohima: An Executive Summary', The Highland Institute, Kohima, Nagaland.
                </>
              ),
              url: 'https://doi.org/10.5281/zenodo.17526229',
            },
          ]}
        />
      </ProfileSection>

      <ProfileContactSection
        email={person.email}
        role="Human Resource Manager, The Highland Institute"
        testidPrefix="rovithono"
      />
    </StaffProfileTemplate>
  );
};

export default RovithonoYhomeProfile;
